const newsletters = {
    api: {
        url: {
            production: "https://subscriptions.cbc.ca/api",
            staging: "https://newsletters-staging.apps.ocp.int.nm.cbc.ca/api",
            dev: "https://newsletters-dev.apps.ocp.int.nm.cbc.ca/api",
            qa: "https://newsletters-qa.apps.ocp.int.nm.cbc.ca/api",
        },
    },
};
export default newsletters;
